export * from './lib/ui-icons.module';
